export const expandAbbreviations = (text: string | null | undefined): string => {
  if (!text) {
    return '';
  }
  return text
    .replace(/\bNYC\s+DOE\b/g, 'New York City Department of Education')
    .replace(/\bDOE\b/g, 'Department of Education')
    .replace(/\bNYSED\b/g, 'New York State Education Department')
    .replace(/\bNYS\b/g, 'New York State');
};
